"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraineeProgressSchema = exports.operatorActivityReportSchema = void 0;
const zod_1 = require("zod");
const operatorThroughputDaySchema = zod_1.z.object({
    day: zod_1.z.string(),
    reviewInflow: zod_1.z.number(),
    reviewOutflow: zod_1.z.number(),
    reviewErrors: zod_1.z.number(),
    reviewCancelled: zod_1.z.number(),
    planInflow: zod_1.z.number(),
    planOutflow: zod_1.z.number(),
    planErrors: zod_1.z.number(),
});
const operatorBacklogDaySchema = zod_1.z.object({
    day: zod_1.z.string(),
    openReviews: zod_1.z.number(),
    openPlans: zod_1.z.number(),
});
const operatorClaimItemSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    displayName: zod_1.z.string(),
    packageId: zod_1.z.string().nullable(),
    mpn: zod_1.z.string().nullable(),
    claimedAt: zod_1.z.number().nullable(),
    ageMs: zod_1.z.number().nullable(),
    expiresAt: zod_1.z.number(),
    isStale: zod_1.z.boolean(),
});
const operatorClaimsSectionSchema = zod_1.z.object({
    activeClaimedReviews: zod_1.z.number(),
    byOperator: zod_1.z.array(zod_1.z.object({ userId: zod_1.z.string(), displayName: zod_1.z.string(), count: zod_1.z.number() })),
    byPackage: zod_1.z.array(zod_1.z.object({ packageId: zod_1.z.string(), mpn: zod_1.z.string().nullable(), count: zod_1.z.number() })),
    items: zod_1.z.array(operatorClaimItemSchema),
});
const operatorClaimableSectionSchema = zod_1.z.object({
    totalClaimableReviewFragments: zod_1.z.number(),
    perOperator: zod_1.z.array(zod_1.z.object({ userId: zod_1.z.string(), displayName: zod_1.z.string(), claimableDepth: zod_1.z.number() })),
});
exports.operatorActivityReportSchema = zod_1.z.object({
    generatedAt: zod_1.z.string(),
    lookbackDays: zod_1.z.number(),
    throughput: zod_1.z.array(operatorThroughputDaySchema),
    backlog: zod_1.z.array(operatorBacklogDaySchema),
    claims: operatorClaimsSectionSchema,
    claimable: operatorClaimableSectionSchema,
});
exports.TraineeProgressSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    assigned: zod_1.z.number().int().nonnegative(),
    completed: zod_1.z.number().int().nonnegative(),
    lastActivityAt: zod_1.z.string().nullable(),
});
//# sourceMappingURL=operator-activity-report.js.map